import React, { PropsWithChildren } from "react";
import { Container } from "react-bootstrap";
import { WaveTopBottomLoading } from "./WaveTopBottomLoading";

interface HeaderJumboProps extends PropsWithChildren {
    title: string;
    description: string;
}

class HeaderJumbo extends React.Component<HeaderJumboProps> {
    render() {
        return (
            <div className="alh_jumbo" style={{ padding: '2rem 0', backgroundColor: '#f8f9fa' }}>
                <div className="overlay">
                    <Container>
                        <h1>{this.props.title}</h1>

                        {this.props.description === "" &&
                            <div className="alhLoadingRel">
                                <WaveTopBottomLoading color="#ffc800" />
                            </div>}

                        <div dangerouslySetInnerHTML={{ __html: this.props.description }} />
                        {this.props.children}
                    </Container>
                </div>
            </div>
        )
    }
}

export default HeaderJumbo;